import { GridCellKind, LoadingCell } from '@glideapps/glide-data-grid';

export const GlideDataGridCellSkeleton = {
    kind: GridCellKind.Loading,
    skeletonWidth: 16 * 11.5,
    skeletonHeight: 16,
    style: 'faded',
    contentAlign: 'center',
} as LoadingCell;
